
      import { ServiceFormPage } from '/src/features/service-form/service-form-page.ts';

      document.addEventListener('DOMContentLoaded', () => {
        new ServiceFormPage({
          formType: 'rentalApplication',
          formEl: 'applicationForm',
          repeatingGroups: [
            {
              containerId: 'rentalHistoryList',
              min: 1,
              max: 5,
              addLabel: '添加居住历史',
              removeLabel: '删除',
              fields: [
                { name: 'rentalAddress', type: 'text', label: '地址' },
                { name: 'rentalPrice', type: 'text', label: '租金' },
                {
                  name: 'rentalType',
                  type: 'select',
                  label: '租房类型',
                  options: [
                    { value: '自有住房', label: '自有住房' },
                    { value: '学生公寓', label: '学生公寓（有合同）' },
                    { value: '房东直租', label: '房东直租（有合同）' },
                    { value: '中介租房', label: '中介租房（有合同）' },
                    { value: '其他', label: '其他（无合同）' },
                  ],
                },
                { name: 'rentalNote', type: 'text', label: '备注' },
                { name: 'rentalStart', type: 'date', label: '起始日期' },
                { name: 'rentalEnd', type: 'date', label: '结束日期' },
                { name: 'rentalContactName', type: 'text', label: '联系人姓名' },
                {
                  name: 'rentalContactRelation',
                  type: 'text',
                  label: '联系人身份',
                  placeholder: '例如：房东/中介/其他请说明',
                },
                { name: 'rentalContactPhone', type: 'tel', label: '联系人电话' },
                { name: 'rentalContactEmail', type: 'email', label: '联系人邮箱' },
              ],
            },
            {
              containerId: 'workHistoryList',
              min: 0,
              max: 3,
              addLabel: '添加工作经历',
              removeLabel: '删除',
              fields: [
                { name: 'companyName', type: 'text', label: '公司名称' },
                { name: 'companyAddress', type: 'text', label: '公司地址' },
                { name: 'jobPosition', type: 'text', label: '职位' },
                { name: 'income', type: 'text', label: '收入情况' },
                { name: 'workStart', type: 'month', label: '起始日期' },
                { name: 'workEnd', type: 'month', label: '结束日期' },
                { name: 'supervisor_name', type: 'text', label: '证明人姓名' },
                { name: 'supervisor_position', type: 'text', label: '证明人职位' },
                { name: 'supervisor_phone', type: 'tel', label: '证明人电话' },
                { name: 'supervisor_email', type: 'email', label: '证明人邮箱' },
              ],
            },
          ],
          conditionals: [
            { watch: 'has_pets', equals: 'yes', show: ['petInfoField'] },
            { watch: 'has_car', equals: 'yes', show: ['carPlateField'] },
          ],
          transform: formData => {
            const birthDate = formData.get('birthDate');
            if (typeof birthDate === 'string' && birthDate) {
              const [year, month, day] = birthDate.split('-');
              if (year && month && day) {
                formData.set('birthDate', `${day}/${month}/${year}`);
              }
            }
            return formData;
          },
          messages: {
            loading: '正在提交租房申请...',
            success: '申请提交成功！我们会尽快处理您的申请。',
          },
          clipboardExport: {
            title: '租房申请信息',
            recipientEmail: 'easyaussie.info@gmail.com',
          },
        });
      });
    